import styled from 'styled-components';
import { em } from 'polished';

import theme from '../../styles/theme';
import { lessThan, greaterThan } from '../../utils/mediaQuery';
import breakpointsRange from '../../utils/breakpointsRange';

export const TextButton = styled.span``;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  h2 {
    margin: 0;

    line-height: 0;
  }
`;

export const Logo = styled.img`
  ${breakpointsRange(
    [{ prop: 'height', sizes: [20, 30] }],
    theme.breakpoints.fonts
  )};

  opacity: 0.66;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  box-sizing: content-box;
  max-width: ${(props) => (props.larger ? '1920px' : '1356px')};
  margin: 0 auto;
  padding: ${em(24)};
  padding-bottom: 0;

  overflow: hidden;

  ${lessThan(theme.breakpoints.fonts[0])} {
    button,
    a {
      min-width: 0;
      padding: 16px;
    }

    a span,
    button span {
      margin: 0 !important;
    }

    ${TextButton} {
      font-size: 0;
    }
  }

  ${greaterThan(theme.breakpoints.fonts[0])} {
    padding: ${em(32)} ${em(32)} 0 ${em(32)};
  }

  ${greaterThan(theme.breakpoints.fonts[1])} {
    padding: ${em(48)} ${em(32)} 0 ${em(32)};
  }

  button > :last-child,
  a > :last-child {
    width: ${em(18)};
  }
`;

const StyledRefinedHeader = styled.header``;

export default StyledRefinedHeader;
